import { PromotionAspect } from "./getPromotionImageSize";

/**
 * Converts an aspect ration string to an integer value
 */
export const aspectRatioToInteger = (aspect: PromotionAspect): number => {
  const aspectValues = aspect.split(":");

  return parseFloat(aspectValues[ 0 ]) / parseFloat(aspectValues[ 1 ]);
};
